<template>
  <div class="p-r" style="line-height: 13px;">
    <div style="width: 138px; height: 8px; border-radius: 4px; background-color: #3b5174; position: relative;overflow:hidden; display: inline-block;" v-if="type==1">
      <img v-if="state==1" src="../../../assets/image/newmould/jd1.png" style="height:8px;position:absolute;max-width:100%" :style="{width:data + '%'}">
      <img v-if="state==2" src="../../../assets/image/newmould/jd2.png" style="height:8px;position:absolute;max-width:100%" :style="{width:data + '%'}">
      <img v-if="state==3" src="../../../assets/image/newmould/jd3.png" style="height:8px;position:absolute;max-width:100%" :style="{width:data + '%'}">
    </div>
    <img src="../../../assets/image/newmould/down.png" v-if="!up&&type==1" style="float:right;margin-right: 15px;">
    <img src="../../../assets/image/newmould/up.png" v-if="up&&type==1" style="float:right;margin-right: 15px;">
    <div style="width: 120px; height: 6px; border-radius: 4px; background-color: #3b5174; position: relative;overflow:hidden;" v-if="type==2" class="bg">
      <div style="position: absolute;max-width: 70%;height:6px;left:0; background-color: #FFA000;" :style="[{width:data + '%'},{borderRadius: data<70?'4px':'0'}]"></div>
      <div style="position: absolute;max-width: 30%;height:6px;left: 70%; border-top-right-radius: 4px; border-bottom-right-radius: 4px; background: linear-gradient(90deg,#FFA000, #00FFA9)" :style="{width:data-70 + '%'}" v-if="data>70"></div>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        up:true
      }
    },
    props: {
      data: {
        type: Number,String,
        request: true
      },
      state: {
        type: Number,
        default: 2
      },
      type: {
        default: 1
      },
    },
    watch:{
      data(val,oldVal){
        if(!this.data){
          this.data = 0
        }else{
          if(val<oldVal){
            this.up = false
          }else if(val>oldVal){
            this.up = true
          }
        }
      }
    }
  }
</script>

<style scoped>
  .bg{
    background-image: url(../../../assets/image/newmould/jdbg.png);
    background-repeat: no-repeat;
    background-size: 70% 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/IndexEdit/mould/ProgressBar.vue